var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"xs12":"","row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"pt-3",attrs:{"sm12":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }